export default __webpack_public_path__ + "static/media/bg.7cf93a29.svg";